import { ImageJsonValue, LinkJsonValue, KeyValue, RenderingProps } from 'src/shared/shared.types';
import { LinkFieldValue } from '@sitecore-jss/sitecore-jss-nextjs';

export type N01HeaderProps = RenderingProps<N01HeaderFields, N01HeaderParams>;

export type N01HeaderFields = {
  data?: {
    header?: HeaderData;
  };
};

export type N01HeaderParams = {
  [key: string]: string | undefined;
};

export interface HeaderData {
  mainNavigation?: {
    targetItem?: N01MainGlobalNavigation;
  };
  utilityNavigation?: {
    targetItem?: N02UtilityNavigation;
  };
}

export interface N01MainGlobalNavigation {
  logo?: {
    jsonValue?: ImageJsonValue;
    width?: number;
    height?: number;
  };
  logoImageInverse?: {
    jsonValue?: ImageJsonValue;
    width?: number;
    height?: number;
  };
  logoUrl?: {
    url?: string;
    jsonValue?: LinkJsonValue;
  };
  logoTitle?: {
    value?: string;
  };
  mobileSupportLink?: {
    jsonValue?: LinkJsonValue;
  };
  searchBarColor?: {
    targetItem?: KeyValue;
  };
  children?: {
    results?: (N01MainGlobalNavigationItem | N01MainGlobalNavigationSection | N12MegaNavigation)[];
  };
}

export interface N01MainGlobalNavigationItem {
  displayName?: string;
  template?: {
    id?: string;
  };
  link?: {
    url?: string;
    text?: string;
    jsonValue?: LinkJsonValue;
  };
  mobileText?: {
    value?: string;
  };
  coloredBarClass?: {
    targetItem?: KeyValue;
  };
}

export interface N01MainGlobalNavigationSection {
  displayName?: string;
  title?: {
    value?: string;
  };
  mobileMegaMenuLink?: {
    jsonValue?: LinkJsonValue;
  };
  coloredBarClass?: {
    targetItem?: KeyValue;
  };
  template?: {
    id?: string;
  };
  children?: {
    results?: (N01MainGlobalNavigationItem | N12MegaNavigation)[];
  };
}

export interface N12MegaNavigation {
  displayName?: string;
  template?: {
    id?: string;
  };
  makeFirstLinkBold?: {
    value?: boolean;
  };
  cTA?: {
    text?: string;
    url?: string;
    target?: string;
    jsonValue?: LinkJsonValue;
  };
  listOfLinks?: {
    jsonValue?: {
      value?: LinkFieldValue[];
    };
  };
  featuredLinks?: {
    jsonValue?: {
      value?: LinkFieldValue[];
    };
  };
}

export interface N02UtilityNavigation {
  cTAButtonLink?: CTAButtonLink;
  cTAButtonLink2?: CTAButtonLink;
  highlightedMobileCTA?: {
    value?: string;
  };
  children?: {
    results?: (N02UtilityNavigationItem | N02UtilityNavigationSection)[];
  };
}

export interface N02UtilityNavigationItem {
  displayName?: string;
  template?: {
    id?: string;
  };
  link?: {
    url?: string;
    text?: string;
    jsonValue?: LinkJsonValue;
    className?: string;
  };
  mobileText?: {
    value?: string;
  };
}

export interface N02UtilityNavigationLanguageSelectorItem {
  displayName?: string;
  template?: {
    id?: string;
  };
  link?: {
    url?: string;
    text?: string;
    jsonValue?: LinkJsonValue;
    className?: string;
  };
  mobileText?: {
    value?: string;
  };
  spanishText?: {
    value?: string;
  };
  spanishLink?: {
    url?: string;
    text?: string;
    jsonValue?: LinkJsonValue;
    className?: string;
  };
  spanishMobileText?: {
    value?: string;
  };
}

export interface N02UtilityNavigationSection {
  displayName?: string;
  template?: {
    id?: string;
  };
  title?: {
    value?: string;
  };
  children?: {
    results?: N02UtilityNavigationItem[];
  };
}

interface CTAButtonLink {
  text?: string;
  url?: string;
  jsonValue?: LinkJsonValue;
}
